import React from 'react';
import { connect } from 'react-redux';

import LoginHOC from '../../../../components/LoginHOC/';
import Spinner from '../../../../components/Spinner';

class GetInvolved extends React.Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    setTimeout(() => this.setState({
      loading: false,
    }), 8000);
  }

  render() {
    if (this.props.authedUser !== null) {
      if (this.props.authedUser.login_string !== null) {
        return (
          <div style={{
            position: 'absolute',
            width: '100%',
            left: '0',
            top: '80px',
          }}>
            {this.state.loading && (
              <div style={{
                padding: '50px',
                position: 'absolute',
                width: '100%',
                zIndex: '5',
              }}>
                <div style={{
                  width: '300px',
                  margin: 'auto',
                  border: '1px solid #ccc',
                  padding: '40px 20px 30px',
                  borderRadius: '5px',
                  background: '#fdfdfd',
                }}>
                  <Spinner />
                  <p style={{ textAlign: 'center', margin: '0', padding: '15px 0' }}>Loading...page will appear blank until loading completes</p>
                </div>
              </div>
            )}
            <iframe style={{ width: '100%', height: 'calc(100vh - 80px)' }}
              src={"https://paragonone.tryretool.com/embedded/public/7c730cf8-408e-4b2a-9c83-e4c4545b9d39?usercode=" + this.props.authedUser.login_string} frameborder="0"></iframe>
          </div>
        );
      }
    }

    return (
      <p>Please logout and relogin to view this page. If this problem persists please contact us</p>
    )
  }
}

const mapStateToProps = (state) => ({
  authedUser: state.auth.User || null,
});

export default (store, index = false) => ({
  path: 'getinvolved',
  component: LoginHOC(connect(mapStateToProps)(GetInvolved)),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/GetInvolved/index.js